import type { UserReturnDto } from '@skillarea/lib-shared';
import { createServerFn } from '@tanstack/react-start';
import { getRequest } from '@tanstack/react-start/server';

export function getApiBaseUrl(): string {
  const base = process.env.SSR_BASE_URL || process.env.SERVER_API_TARGET;
  if (base) return base.replace(/\/$/, '');
  const port = process.env.HTTP_PORT || '3001';
  return `http://localhost:${port}`;
}

export async function fetchUserFromRequest(
  request: Request,
): Promise<UserReturnDto | null> {
  const cookie = request.headers.get('Cookie');
  if (!cookie) return null;
  const base = getApiBaseUrl();
  const response = await fetch(`${base}/api/user/self`, {
    headers: { Cookie: cookie },
  });
  if (!response.ok) return null;
  const json = (await response.json()) as { data?: UserReturnDto };
  const raw = json?.data;
  if (!raw || raw.id == null) return null;
  return raw;
}

export const fetchAuthUser = createServerFn({ method: 'GET' }).handler(
  async (): Promise<UserReturnDto | null> => {
    const request = getRequest();
    return fetchUserFromRequest(request);
  },
);
